export const getters = {
  cartItems: (state) => {
    return state.cart.cartItems ?? [];
  },
  loggedIn: (state) => {
    return state.customerID !== null;
  },
  persons: (state) => {
    return state.persons ?? [];
  },
  actionCode: (state) => {
    return state.cart.actionCode ?? null;
  },
  customerID: (state) => {
    return state.customerID ?? null;
  },
  cartLastUpdated: (state) => {
    return state.cartLastUpdated ?? null;
  },
};
